import { AppBar, Button, Grid2, Toolbar } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import prestoLogo from "../Assets/Presto_Logo.png";
import { Lang } from "../Utils/Constants";

const Header: React.FC<{ handleMicrosoftRedirect: any }> = ({ ...props }) => {
  const sxProps = {
    appBar: {
      top: "auto",
      bottom: 0,
      backgroundColor: "#000000",
      borderBottom: "3px solid #72b34b",
    },
    innerGrid: {
      display: "flex",
      width: "56%",
      backgroundColor: "#000000",
      justifyContent: "flex-end",
      alignItems: "center",
      "@media (max-width: 1024px)": {
        width: "60%",
      },
    },
    langGrid: {
      display: "flex",
      width: "42%",
      backgroundColor: "#000000",
      justifyContent: "flex-end",
    },
    buttonTypo: {
      textTransform: "none",
      fontFamily: "AvenirNextProMedium, Arial",
      color: "white",
      "&:focus-visible": {
        outline: 1,
      },
    },
  };
  const { t, i18n } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState<string>(
    localStorage.getItem("i18nextLng") || Lang.En
  );

  const toggleLanguage = () => {
    const lang = selectedLanguage === Lang.En ? Lang.Fr : Lang.En;
    setSelectedLanguage(lang);
    i18n.changeLanguage(lang);
    localStorage.setItem("i18nextLng", lang);
  };

  useEffect(() => {
    const storedLang = localStorage.getItem("i18nextLng");
    if (storedLang && storedLang !== selectedLanguage) {
      i18n.changeLanguage(storedLang);
      setSelectedLanguage(storedLang);
    }
    document.documentElement.lang = storedLang === Lang.En ? Lang.en : Lang.fr;
  }, [i18n, selectedLanguage]);

  return (
    <AppBar position="static" style={sxProps.appBar}>
      <Toolbar>
        <Grid2 sx={{ display: "flex", width: "100%" }}>
          <Grid2 sx={sxProps.innerGrid}>
            <img
              src={prestoLogo}
              alt="Presto logo"
              style={{ height: "22.7px" }}
            />
          </Grid2>
          <Grid2 sx={sxProps.langGrid}>
            <Button
              id="lang-toggle"
              color="inherit"
              onClick={toggleLanguage}
              sx={sxProps.buttonTypo}
              aria-label={`Switch to ${
                selectedLanguage === Lang.En ? Lang.French : Lang.English
              }`}
              disableRipple
            >
              {selectedLanguage === Lang.En ? Lang.FR : Lang.EN}
            </Button>
            <Button
              id="btn-signOut"
              color="inherit"
              onClick={props.handleMicrosoftRedirect}
              data-testid="signOutBtn"
              sx={sxProps.buttonTypo}
              aria-label={t("signOut")}
              disableRipple
            >
              {t("signOut")}
            </Button>
          </Grid2>
        </Grid2>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
